import { Pipe } from "@angular/core";
import { ValidationErrors } from "@angular/forms";

import { getInverterSerialErrorMessage, getUserEmailErrorMessage } from "../create-firebase/create.utils";

@Pipe({
  name: 'deviceSerialValidatorPipe',
  standalone: true,
})
export class DeviceSerialValidatorPipe {
  transform(value: ValidationErrors | undefined | null, labels: any): string {
    return value ? getInverterSerialErrorMessage(labels, value) : '';
  }
}

@Pipe({
  name: 'userEmailValidatorPipe',
  standalone: true,
})
export class UserEmailValidatorPipe {
  transform(value: ValidationErrors | undefined | null, labels: any): string {
    return value ? getUserEmailErrorMessage(labels, value) : '';
  }
}
